import { HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

export type BadgeTone = "default" | "good" | "bad" | "warn" | "muted" | "info";

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone;
}

const toneClasses: Record<BadgeTone, string> = {
  default: "bg-bg text-fg border border-border",
  good: "bg-good/15 text-good border border-good/30",
  bad: "bg-bad/15 text-bad border border-bad/30",
  warn: "bg-warn/15 text-warn border border-warn/30",
  muted: "bg-bg text-muted border border-border",
  info: "bg-accent/15 text-accent border border-accent/30",
};

export function Badge({ className, tone = "default", ...props }: BadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium",
        toneClasses[tone],
        className,
      )}
      {...props}
    />
  );
}
